import { render, staticRenderFns } from "./PickingCardResume.vue?vue&type=template&id=311dbfb6&scoped=true"
import script from "./PickingCardResume.vue?vue&type=script&lang=js"
export * from "./PickingCardResume.vue?vue&type=script&lang=js"
import style0 from "./PickingCardResume.vue?vue&type=style&index=0&id=311dbfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311dbfb6",
  null
  
)

export default component.exports